module.exports = __webpack_public_path__ + "static/media/corporate-img-2.a2f369cc.png";